import React from 'react';
import { Link } from 'react-router-dom';
import SiteNav from '@/components/layout/SiteNav';
import SiteFooter from '@/components/layout/SiteFooter';
import MetaTags from '@/components/SEO/MetaTags';
import { useLanguage } from '@/i18n/LanguageProvider';
import '@/styles/vani-landing.css';

export default function ForHospitalsPage() {
  const { t } = useLanguage();
  return (
    <div className="vani-home">
      <MetaTags
        title={t.hospTitle}
        description={t.hospDesc}
        path="/for-hospitals"
      />
      <SiteNav />
      <header className="vani-hero" id="top" style={{ backgroundImage: 'none' }}>
        <div className="vani-wrap">
          <div className="vani-pill">
            <b>{t.hospPill}</b> · $10,000 / month
          </div>
          <h1>
            {t.hospH1}
          </h1>
          <p className="vani-lede">
            {t.hospLede}
          </p>
          <div className="vani-cta-row">
            <a className="vani-btn vani-btn-primary" href="mailto:care@getbyonco.com?subject=Hospital%20SaaS%20demo">
              {t.requestDemo}
            </a>
            <Link className="vani-btn vani-btn-ghost" to="/platform">{t.hospMarketplace}</Link>
          </div>
        </div>
      </header>

      <section className="vani-price-band">
        <div className="vani-wrap">
          <div className="vani-center vani-reveal in">
            <div className="vani-eyebrow">{t.hospSkuEyebrow}</div>
            <h2>{t.hospSkuH2}</h2>
            <p className="vani-sub">{t.hospSkuSub}</p>
          </div>
          <div className="vani-grid vani-g3" style={{ marginTop: 36 }}>
            <div className="vani-card vani-reveal in">
              <h3>{t.hospRefH}</h3>
              <p>{t.hospRefP}</p>
            </div>
            <div className="vani-card vani-reveal in">
              <h3>{t.hospBedsH}</h3>
              <p>{t.hospBedsP}</p>
            </div>
            <div className="vani-card vani-reveal in">
              <h3>{t.hospEmrH}</h3>
              <p>{t.hospEmrP}</p>
            </div>
          </div>
          <div className="vani-cta-row" style={{ marginTop: 40 }}>
            <a className="vani-btn vani-btn-primary" href="mailto:care@getbyonco.com?subject=Hospital%20SaaS%20demo">
              {t.hospPartners}
            </a>
          </div>
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
